import styled from 'styled-components';

export const Nav = styled.nav`
  background: ${props => props.theme.primary};
`;

export const Logo = styled.img`
  width: 100px;
`;